import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss']
})
export class GuideComponent implements OnInit {

  menus= [
    { label: 'CRM', active:true },
    { label: 'Inventory', active:false },
    { label: 'Field Service', active:false },
    { label: 'Finance', active:false },
  ];
  items: MenuItem[];
  commonItems: MenuItem[];
  selectedWindow;
  pdfSrc = '../../assets/pdf/createAccount.pdf';

  constructor() { }

  ngOnInit(): void {
    this.getItems(this.menus[0]);
  }

  getItems(event){
    for(let s of this.menus){
      if(s.label == event.label){
        s.active = true;
      } else {
        s.active = false;
      }
    }
    if(event.label == 'CRM'){
      this.items = [
        {
          label: 'Accounts',
          items: [
            {
              label: 'Overview',
            },
            {
              label: 'How to',
              items: [
                {
                  label: 'Create Account',
                  command: () => {
                    this.selectedWindow = 'add-account';
                  }
                },
                {
                  label: 'Update Account',
                  command: () => {
                    this.selectedWindow = 'edit-account';
                  }
                },
                {
                  label: 'View Account',
                  command: () => {
                    this.selectedWindow = 'view-account';
                  },
                  items:[
                    {
                      label: 'Listing view'
                    },
                    {
                      label: 'Details view'
                    },
                  ]
                },
                {
                  label: 'Delete Account',
                  command: () => {
                    this.selectedWindow = 'delete-account';
                  }
                },
                {
                  label: 'Customize Account Setting',
                  command: () => {
                    this.selectedWindow = 'setting';
                  }
                },
              ],
            },
          ]
        },
        {
          label: 'Cases',
          items:[
            
          ]
        },
        {
          label: 'Contacts',
          items: [
              
          ]
        },
        {
          label: 'Leads',
          items: [
           
          ]
        },
        {
          label: 'Opportunities',
          items: [
           
          ]
        },
        {
          label: 'Sales Quota',
          items: [
           
          ]
        },
      ]
    } else if (event.label == 'Inventory'){
      this.items = [
        {
          label: 'Locations',
          items: [
           
          ]
        },
        {
          label: 'Products',
          items: [
           
          ]
        },
        {
          label: 'Purchases',
          items: [
           
          ]
        },
        {
          label: 'Sales',
          items: [
           
          ]
        },
      ]
    } else if (event.label == 'Field Service'){
      this.items = [
        {
          label: 'Questionnaire',
          items: [
           
          ]
        },
        {
          label: 'Routes',
          items: [
           
          ]
        },
        {
          label: 'Territory',
          items: [
           
          ]
        },
      ]
    } else if (event.label == 'Finance'){
      this.items = [
        {
          label: 'Charts of Accounts',
          items: [
           
          ]
        },
        {
          label: 'Journals',
          items: [
           
          ]
        },
      ]
    }
    this.commonItems = [
      {
        label: 'Activities',
        items:[
          
        ]
      },
      {
        label: 'Configurations',
        items: [
            
        ]
      },
      {
        label: 'Dashboard',
        items: [
            
        ]
      },
      {
        label: 'Reports',
        items: [
         
        ]
      },
      {
        label: 'Setting',
        items:[
          {
            label:"Change Password",
          },
          {
            label:"Display Setting",
          },
          {
            label:"Profile",
          },
        ]
      },
    ]
  }
}
